import { mergeMap, Observable, of, OperatorFunction, throwError } from 'rxjs';

interface ApolloResponseBase {
  data?: any;
  errors?: any;
}

export function apolloThrowIfNotSuccess<T extends ApolloResponseBase>(
  entityName: string,
): OperatorFunction<T, T> {
  return (source$: Observable<T>) =>
    source$.pipe(
      mergeMap((value) => {
        if (
          value === undefined ||
          value?.data === undefined ||
          value?.errors ||
          value.data?.[entityName]?.isSuccess === false
        ) {
          return throwError(() => {
            const message = value?.data?.[entityName]?.message;

            return new Error(message || 'Unknown error');
          });
        }

        return of(value);
      }),
    );
}
